// extracted by mini-css-extract-plugin
export default {"main":"Skills_main__ftFQ+","tech":"Skills_tech__W-gP1","tool":"Skills_tool__-Fj2T","flip":"Skills_flip__Kk9OF"};